import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrVideoIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M14.5 5.1C14.3 5 14 5 13.8 5.1L11.6 6.3C11.6 5.7 11.3 5.1 10.9 4.7C10.4 4.2 9.8 4 9.2 4H2.2C1.9 4 1.6 4.1 1.4 4.3C1.1 4.4 1 4.7 1 5V10.3C1 11 1.3 11.6 1.7 12C2.2 12.5 2.8 12.7 3.4 12.7H10.4C10.7 12.7 11 12.6 11.2 12.4C11.4 12.2 11.5 11.9 11.5 11.6V10.4L13.7 11.6C13.9 11.7 14.2 11.7 14.4 11.6C14.6 11.5 14.7 11.2 14.7 11V5.7C14.8 5.4 14.7 5.2 14.5 5.1ZM3.5 11.4C3.2 11.4 2.9 11.3 2.7 11.1C2.5 10.9 2.4 10.6 2.4 10.3V5.3H9.2C9.5 5.3 9.8 5.4 10 5.6C10.2 5.8 10.3 6.1 10.3 6.3V11.4H3.5ZM13.4 9.8L11.6 8.8V7.8L13.4 6.8V9.8Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrVideoIconComponent;
